/* To implements tabs :
 * Give "tabs" as id for the global tabs container
 * Add the class "category-tabs" to the list of tabs titles (usually a <ul>)
 */
(function ($) {
    $(window).on('load', function () {
		jQuery(document).ready(function($) {
			//if (window.innerWidth > 980) {
				$("#tabs").tabs();
			// }
		});
    });
})(jQuery);
